import { Signal } from '@angular/core';

export function keyof<T>(key: keyof T & string): string {
  return key.toString();
}

export function typed<T>(val: T): T {
  return val;
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isOptionalBoolean(value: unknown): value is boolean | undefined {
  return value === undefined || typeof value === 'boolean';
}

export type RequireAtLeastOne<T, Keys extends keyof T = keyof T> =
  Pick<T, Exclude<keyof T, Keys>>
  & {
    [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>
  }[Keys];

export type ArrayElement<T> = T extends (infer U)[] ? U : never;

export type SignalElement<T> = T extends Signal<infer U> ? U : never;
